// @ts-nocheck








import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { fetchRequest } from './index';


export const convertDataToServer = (
fuelAndOilCalculation) => (
{
  ...fuelAndOilCalculation,
  sum: convertFromRubToKop(fuelAndOilCalculation.sum),
  months: fuelAndOilCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
fuelAndOilCalculation) => (
{
  ...fuelAndOilCalculation,
  sum: convertFromKopToRub(fuelAndOilCalculation.sum),
  months: fuelAndOilCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
fuelAndOilCalculationMonth) => (
{
  ...fuelAndOilCalculationMonth,
  // $FlowFixMe count and type в spread операторе
  fuel: {
    ...fuelAndOilCalculationMonth.fuel,
    cost: convertFromRubToKop(fuelAndOilCalculationMonth.fuel?.cost)
  },
  oils: fuelAndOilCalculationMonth.oils?.map(
    (el) => ({
      ...el,
      cost: convertFromRubToKop(el.cost)
    })
  ),
  oilsSum: convertFromRubToKop(fuelAndOilCalculationMonth.oilsSum)
});

export const convertDataFromServerMonth = (
fuelAndOilCalculationMonth) => (
{
  ...fuelAndOilCalculationMonth,
  // $FlowFixMe count and type в spread операторе
  fuel: {
    ...fuelAndOilCalculationMonth.fuel,
    cost: convertFromKopToRub(fuelAndOilCalculationMonth.fuel?.cost)
  },
  oils: fuelAndOilCalculationMonth.oils?.map(
    (el) => ({
      ...el,
      cost: convertFromKopToRub(el.cost)
    })
  ),
  oilsSum: convertFromKopToRub(fuelAndOilCalculationMonth.oilsSum)
});

const basedUrl = 'fuelAndOilCalculation';
const fuelAndOilCalculation = new CommonApi(
  basedUrl,
  'расчет гсм',
  convertDataToServer,
  convertDataFromServer
);

export const updateCalculations = async (
data) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculations`,
    convertDataToServer(data)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error(`Не удалось отредактировать`);
};

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

export default {
  ...fuelAndOilCalculation,
  updateCalculations,
  calculate,
  changeStatus
};
